import { render, staticRenderFns } from "./IntegrationHub.vue?vue&type=template&id=2d462915"
import script from "./IntegrationHub.vue?vue&type=script&lang=js"
export * from "./IntegrationHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports